import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_menu_item = _resolveComponent("a-menu-item");
  const _component_a_sub_menu = _resolveComponent("a-sub-menu");
  const _component_a_menu = _resolveComponent("a-menu");
  const _component_a_dropdown = _resolveComponent("a-dropdown");
  return _openBlock(), _createBlock(_component_a_dropdown, null, {
    overlay: _withCtx(() => [_createVNode(_component_a_menu, {
      onClick: _cache[0] || (_cache[0] = menu => $setup.handleMenuClick(menu.key))
    }, {
      default: _withCtx(() => [_createVNode(_component_a_menu_item, {
        key: "closeCur"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode(" 关闭当前窗口 ", -1)]))]),
        _: 1
      }), _createVNode(_component_a_menu_item, {
        key: "closeOther"
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode(" 关闭其他窗口 ", -1)]))]),
        _: 1
      }), _createVNode(_component_a_menu_item, {
        key: "closeAll"
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode(" 关闭所有窗口 ", -1)]))]),
        _: 1
      }), _createVNode(_component_a_sub_menu, {
        title: "窗口",
        trigger: "hover"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, (item, idx) => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: item.path
          }, [item.path === $props.activeKey ? (_openBlock(), _createBlock(_component_a_menu_item, {
            key: idx,
            class: "ant-menu-item-selected",
            onClick: e => $setup.handleWinMenuClick(item, e)
          }, {
            default: _withCtx(() => [_cache[4] || (_cache[4] = _createElementVNode("span", {
              class: "win-dropdown-menu-icon-bd"
            }, [_createElementVNode("i", {
              class: "fa fa-check-square-o fa-1x"
            })], -1)), _createTextVNode(" " + _toDisplayString(item.title), 1)]),
            _: 2
          }, 1032, ["onClick"])) : (_openBlock(), _createBlock(_component_a_menu_item, {
            key: idx,
            onClick: e => $setup.handleWinMenuClick(item, e)
          }, {
            default: _withCtx(() => [_cache[5] || (_cache[5] = _createElementVNode("span", {
              class: "win-dropdown-menu-icon-bd"
            }, null, -1)), _createTextVNode(" " + _toDisplayString(item.title), 1)]),
            _: 2
          }, 1032, ["onClick"]))], 64);
        }), 128))]),
        _: 1
      })]),
      _: 1
    })]),
    default: _withCtx(() => [_cache[6] || (_cache[6] = _createElementVNode("span", {
      class: "win-dropdown-menu-icon"
    }, [_createElementVNode("i", {
      class: "fa fa-ellipsis-h"
    })], -1))]),
    _: 1
  });
}